import { createContext } from 'react';

import { DevAppContext } from '../../models';

const devAppContext: DevAppContext = {
        setMapContext: () => {},
        setSelectedProvider: () => {},
        setProviders: () => {},
        showLoading: false,
        setShowLoading: () => {},
        // currentPageNumber: 0,
        // setCurrentPageNumber: () => {},
        // currentPageSize: 0,
        // setCurrentPageSize: () => {},
        // pageAnchor: 0,
        // setPageAnchor: () => {},
        setProviderSearchParams: () => {},
        setProviderAuxiliaryData: () => {}
    };
export const DevContext = createContext(devAppContext);